import { msg } from 'gt-react';
import { ClipboardTextIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { Route as pathlessAuthenticatedRoute, requireModules } from '../route';

const CustomerProductMatchesPage = lazyRouteComponent(
  () => import('./CustomerProductMatchesPage'),
  'CustomerProductMatchesPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/customer-product-matches',
  staticData: {
    app: {
      nav: {
        label: msg('Product Matches', {
          context: 'sidebar nav label, Sales section',
        }),
        icon: <ClipboardTextIcon className="h-4 w-4" weight="fill" />,
        group: 'Sales',
        order: 30,
      },
      access: {
        modulesAnyOf: [ProductModule.ORDER_MANAGEMENT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.Customer },
          { action: Action.Read, subject: Subject.SalesOrder },
        ],
      },
    },
  },
  component: CustomerProductMatchesPage,
  loader: () => ({
    crumb: msg('Customer Product Matches', { context: 'page breadcrumb' }),
  }),
  validateSearch: z.object({
    customerId: z.string().optional(),
    productId: z.string().optional(),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});
